import { AccountContactMergeData, AccountContactMergeSchema, AccountMergeData, AccountMergeSchema, CompanyMergeData, CompanyMergeSchema, EmployeeMergeData, EmployeeMergeSchema, JobSiteMergeData, JobSiteMergeSchema, OpportunityMergeData, OpportunityMergeSchema } from '../data';
import { ActivityEntityName } from '../../../../entities';
import { MergeDataset, MergeSource } from '../../decorators';

@MergeDataset({
    entity: ActivityEntityName.Opportunity
})
export class OpportunityMergeDataset {

    @MergeSource({
        schema: OpportunityMergeSchema
    })
    opportunity: OpportunityMergeData;

    @MergeSource({
        schema: AccountMergeSchema
    })
    opportunityAccount: AccountMergeData;

    @MergeSource({
        schema: AccountContactMergeSchema
    })
    opportunityContact: AccountContactMergeData;

    @MergeSource({
        schema: JobSiteMergeSchema
    })
    opportunitySite: JobSiteMergeData;

    @MergeSource({
        schema: EmployeeMergeSchema
    })
    opportunityOwner: EmployeeMergeData;

    @MergeSource({
        schema: CompanyMergeSchema
    })
    opportunityCompany: CompanyMergeData;

    public static get empty() {
        return {
            opportunity: new OpportunityMergeData(),
            opportunityAccount: new AccountMergeData(),
            opportunityContact: new AccountContactMergeData(),
            opportunitySite: new JobSiteMergeData(),
            opportunityOwner: new EmployeeMergeData(),
            opportunityCompany: new CompanyMergeData()
        } as OpportunityMergeDataset;
    }

}